import React from 'react';
import emptyData from '../../../../assets/images/landing/empty-data.svg';
import st from './style.module.scss';
import { getEmptyDataText } from './constants';
import { useTranslation } from 'react-i18next';

const EmptyData = ({ type }) => {
  const { t } = useTranslation();
  const EMPTY_DATA_TEXT = getEmptyDataText(t);
  const text = EMPTY_DATA_TEXT[type];
  return (
    <div className="col-12 px-2">
      <div className={st.emptyDataWrap}>
        <img
          src={emptyData}
          alt="empty data image"
          className="img-fluid"
          style={{ maxWidth: '100%', height: 'auto' }}
        />
        <div className={st.emptyDataText}>
          <h4>{text.title}</h4>
          <span>{text.description}</span>
        </div>
      </div>
    </div>
  );
};

export default EmptyData;
